/* unplugin-vue-components disabled */import script from "./Activity.vue?vue&type=script&lang=ts&setup=true"
export * from "./Activity.vue?vue&type=script&lang=ts&setup=true"

import "./Activity.vue?vue&type=style&index=0&id=71e0cb0d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e0cb0d"]])

export default __exports__